import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, getContatById, valuesAnalyze, changeViewForms, createPhone, updateContact, deletePhone, deleteContact, updatePhone, clickToCall } from '../../services';

import Loading from '../../components/Loading/LoadingModule';
import PhoneCard from './PhoneListCard';
import InputSetPhone from './PhoneCreate';
import InputEditPhone from './PhoneEdit';

import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

function UpdateCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit, toggleIsHidden, toggleIsChangeFormElements, itemsSelectedToEdit, } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [ph, setPh] = useState([]);
  const [disable, setDisable] = useState(true);
  const [phoneModify, setPhoneModify] = useState({});
  const [inputPhone, setInputPhone] = useState({});
  const [idModPhone, setIidModPhone] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    const contactFetch = await getContatById({ id: itemsSelectedToEdit });
    if(itemsSelectedToEdit.length <= 0) return history.push('/agenda/lista');
    if(contactFetch === undefined) setLoading(true);
    if(contactFetch['phones'].length > 0) setPh(contactFetch['phones']);
    setValues(contactFetch);
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj' || name === 'numberphone' || name === 'editnumberphone') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'company' || name === 'addr') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const insertNumberPhone = () => {
    changeVisibityMessages(true, 'buttons-edit-contact');
    changeVisibityMessages(true, 'list-phones');
    changeVisibityMessages(false, 'input-phone');
  };

  const handleChangeInput = (item) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setInputPhone({ number: Number(value), contactid: values['idcont'] })
  };

  const handleChangeInputPhoneEdit = (item, idPhone) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setPhoneModify({ phone: Number(value), id: idModPhone })
  };

  const saveNewPhone = async () => {
    try {
      const newPhone = await createPhone(inputPhone);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
  
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const cancelCreatePhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const saveEditedPhone = async () => {
    const newPhone = await updatePhone(phoneModify);
    setItemsSelectedToEdit(phoneModify);
    await validateUserLogged();

    changeVisibityMessages(false, 'buttons-edit-contact');
    changeVisibityMessages(false, 'list-phones');
    changeVisibityMessages(true, 'input-edit-phone');
  };

  const cancelEditedPhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-edit-phone');
    } catch (error) {
      console.log(error)
    }
  };

  const handleClickDelete = async () => {
    try {
      const sendDeleteContact = await deleteContact({ id: values['idcont'] });
      toggleIsHidden('#update-form');
      // toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#success-deleted-contacts');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    } catch (error) {
      toggleIsHidden('#update-form');
      toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#error-delete-contact');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/home');
      }, 3000);
    }
  };

  const handleClickDeletePhone = async (data) => {
    const { value, phone } = data;
    try {
      const sendDeleteContact = await deletePhone({ id: Number(value) });
      if(values['phones'].length === 1) history.push('/agenda/lista');
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
    } catch (error) {
      changeVisibityMessages(false, `delete-phone-link-${value}`);
      changeVisibityMessages(true, `delete-phone-confirm-${value}`);
    }

  };
  
  const sendDataContactUpdate = async () => {
    const updateContactSend = await updateContact({
      id: values['idcont'],
      company: values['compname'],
      fantasy: values['namefantasy'],
      addr: values['addr'],
      cnpj: Number(values['cnpj']),
      email: values['mail'],
      alias: values['alias'],
      comment: values['comm'],
    });

    const result = Object.keys(updateContactSend).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
      changeVisibityMessages(false, 'success-updeted-contacts');
      setTimeout(() => {
        return changeVisibityMessages(true, 'success-updeted-contacts');
      }, 3000);
    };
    return;
  };

  
  const handleClickToCall = async (phone) => {
    let phoneFull = phone;
    if(phoneFull.length === 10 || phoneFull.length === 11) phoneFull = `0${phone}`;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = { 
      name: `${values['namefantasy']}`,
      dest: phoneFull,
      exten: user.endpoint
    }
    console.log(myEndpoint);
    const result = await clickToCall(myEndpoint);
  };

  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">EDITAR CONTATO</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-confirm-contact-delete" name="alert-confirm-contact-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-contact-delete') }></button>
            </div>
            <div className="message-body">
              Tem certeza que quer deletar o contato?
            </div>
            <br />
            <div className="columns">
              <div className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Confirmar
                      </span>
                </button>
                <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                  toggleIsHidden('#alert-confirm-contact-delete')
                  toggleIsHidden('#buttons-edit-contact')
                }}>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faArrowLeft } fixedWidth />
                  </span>
                  <span>
                    Cancelar
                  </span>
                </button>
              </div>
            </div>
          </article>
          <article id="error-delete-contact" name="error-delete-contact" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Erro!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#error-delete-contact') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar o contato!
            </div>
          </article>
          <article id="success-deleted-contacts" name="success-deleted-contacts" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-deleted-contacts') }></button>
            </div>
            <div className="message-body">
              Contato deletado com <strong>sucesso</strong>!
            </div>
          </article>
          <article id="success-updeted-contacts" name="success-updeted-contacts" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-updeted-contacts') }></button>
            </div>
            <div className="message-body">
              Contato atualizado com <strong>sucesso</strong>!
            </div>
          </article>
          <form name="update-form" id="update-form" onSubmit={ (e) =>  e.preventDefault() }>
            <div className="columns mx-2">
              <div className="column is-2 is-offset-3 field">
                <label className="label">Razão Social
                  <div className="control">
                  <input className="input" name="compname" type="text" defaultValue={ values['compname']} onChange={(e) => handleChangeValues(e.target)} placeholder="Razão Social" />
                  <p name="compname-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Nome Fantasia
                  <div className="control">
                  <input className="input" name="namefantasy" type="text" defaultValue={ values['namefantasy']} onChange={(e) => handleChangeValues(e.target)} placeholder="Nome Fantasia" />
                  <p name="namefantasy-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Endereço
                  <div className="control">
                  <input className="input" name="addr" type="text" defaultValue={ values['addr']} onChange={(e) => handleChangeValues(e.target)} placeholder="Rua Abc, 1000"/>
                  <p name="addr-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
                </label>
              </div>
            </div>
            <div className="columns mx-2">
              <div className="column is-2 is-offset-3 field">
                <label className="label">CNPJ/CPF
                  <div className="control">
                    <input className="input" name="cnpj" type="text" defaultValue={ values['cnpj']} onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas números"/>
                    <p name="cnpj-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">E-mail
                  <div className="control">
                    <input className="input" name="mail" type="text" defaultValue={ values['mail']} onChange={(e) => handleChangeValues(e.target)} placeholder="empresa@email.com.br"/>
                    <p name="mail-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Apelido
                  <div className="control">
                    <input className="input" name="alias" type="text" defaultValue={ values['alias']} onChange={(e) => handleChangeValues(e.target)} placeholder="Apelido"/>
                    <p name="alias-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </label>
              </div>
            </div>
            <div className="columns mx-2">
              <div className="column is-half is-offset-3 field">
                <label className="label">Comentários
                  <div className="control">
                  <input className="input" name="comm" type="text" defaultValue={ values['comm'] !== 'undefined' ? values['comm'] : ''} onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas texto e números. (-_,)"/>
                  <p name="comm-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
            </div>
          </form>
          <div id="buttons-edit-contact" name="buttons-edit-contact" className="columns mt-2">
            <div className="field column mt-3 is-half is-offset-one-quarter has-text-centered">
              <div className="control">
                <button className="button is-info is-3 mt-3 ml-4 mr-2 px-6" type="submit" onClick={() => sendDataContactUpdate() }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faSave } fixedWidth />
                  </span>
                  <span>
                    Salvar Alterações
                  </span>
                </button>
                <button name="insert-phone" className="button is-primary is-3 mt-3 mx-2 px-5" type="submit" onClick={() => insertNumberPhone()}>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                  </span>
                  <span>
                    Adicionar Telefone
                  </span>
                </button>
                <button name="insert-phone" className="button is-danger is-3 mt-3 mx-2 px-5" type="submit" onClick={ () => {
                  toggleIsHidden('#alert-confirm-contact-delete')
                  toggleIsHidden('#buttons-edit-contact')
                } }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                  </span>
                  <span>
                    Deletar Contato
                  </span>
                </button>
              </div>
            </div>
          </div>
          <br/>
          <div name="input-phone" className="columns is-half is-hidden px-2">
            <div className="field column card is-half is-offset-one-quarter px-2 has-text-centered">
              <InputSetPhone handleChangeinput={ handleChangeInput } save={ saveNewPhone } cancel={ cancelCreatePhone }/>
            </div>
            <br/>
          </div>
          <div name="input-edit-phone" id="input-edit-phone" className="columns is-half is-hidden px-2">
            <div className="field column card is-half is-offset-one-quarter px-2 has-text-centered">
              <InputEditPhone handleChangeInput={ handleChangeInputPhoneEdit } save={ saveEditedPhone } phoneModify={ phoneModify } setPhoneModify={ setPhoneModify } cancel={ cancelEditedPhone }/>
            </div>
            <br/>
          </div>
          <div id="list-phones" name="list-phones" className="columns px-2 is-multiline is-centered is-narrow has-text-centered">
            { ph.map((phone) => <PhoneCard key={phone.phonenumber} phones={ phone } changeVisibityMessages={ changeVisibityMessages } handleClickToCall={ handleClickToCall } setPhoneModify={ setPhoneModify } setIidModPhone={ setIidModPhone } del={ handleClickDeletePhone }/>) }
          </div>
        </div>
      }
    </div>
  );
}

export default UpdateCreate;
